var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24826 11.4338V15.4354",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7516 10.4313H13.7008V8.73064C13.7008 8.15033 13.2306 7.67975 12.6503 7.6792H12.2502C11.8985 7.6792 11.5726 7.86373 11.3918 8.1654L9.78414 10.8455C9.59757 11.1565 9.49902 11.5123 9.49902 11.8749V14.6851C9.49902 15.2376 9.94693 15.6855 10.4994 15.6855H14.6802C15.015 15.6859 15.3277 15.5188 15.5135 15.2403L16.584 13.6337C16.6936 13.4693 16.752 13.2761 16.752 13.0784V11.4318C16.752 10.8792 16.3041 10.4313 15.7516 10.4313Z",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12,
    r: 9.00375,
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.9cc80b376d39e7cfe11ec065c3330f8b.svg";
export { ForwardRef as ReactComponent };